import { Button } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useSaveDemandRequest } from '../../common/useSaveDemandRequest';
import { NegotiationCaseCreateWizardState } from '../NegotiationCaseCreateWizard/NegotiationCaseCreateWizard.schema';
import { I18nNamespace } from '~/common/types';
import { DialogActionsLayout } from '~/components/DialogWizard/components/DialogActionsLayout/DialogActionsLayout';
import { useWizardFormControls } from '~/components/WizardState/hooks/useWizardFormControls/useWizardFormControls';

import { useCreateCase } from './useCreateCase';

export const NegotiationCaseStepActions = () => {
  const { t: tGeneralActions } = useTranslation(I18nNamespace.common, { keyPrefix: 'DialogWizard.general.actions' });
  const { t } = useTranslation(I18nNamespace.demand, {
    keyPrefix: 'NegotiationCaseCreate.wizard.CreateNegotiationCase.actions',
  });

  const saveDemandRequest = useSaveDemandRequest();
  const createNegotiationCase = useCreateCase();

  const saveDemandRequestAndCreateNegotiationCase = useCallback(
    async (data: NegotiationCaseCreateWizardState) => {
      const saveDemandResult = await saveDemandRequest(data);
      if (!saveDemandResult.success) {
        return saveDemandResult;
      }
      return await createNegotiationCase(data);
    },
    [createNegotiationCase, saveDemandRequest],
  );

  const { submit, cancel, disabled } = useWizardFormControls<NegotiationCaseCreateWizardState>(
    saveDemandRequestAndCreateNegotiationCase,
  );

  return (
    <DialogActionsLayout
      left={<Button onClick={cancel}>{tGeneralActions('cancel')}</Button>}
      right={
        <Button variant="contained" color="primary" disabled={disabled} onClick={submit}>
          {t('createNegotiationCase')}
        </Button>
      }
    ></DialogActionsLayout>
  );
};
